import {BatteryCharging} from 'lucide-react'

function Nav() {
  return (
    <header className="sticky top-0 z-40 backdrop-blur-xl bg-[#FAF8F5]/75 border-b border-slate-900/[0.06]">
      <div className="max-w-[1400px] mx-auto px-6 lg:px-12 h-16 flex items-center justify-between">
        <a href="#top" className="flex items-center gap-2.5 group">
          <div className="relative">
            <div className="absolute inset-0 bg-amber-400/30 blur-md group-hover:bg-amber-400/50 transition" />
            <div className="relative w-8 h-8 rounded-md bg-slate-900 flex items-center justify-center">
              <BatteryCharging className="w-4 h-4 text-amber-400" strokeWidth={2.2} />
            </div>
          </div>
          <div className="leading-none">
            <div className="font-display text-[17px] font-semibold tracking-tight text-slate-900">Saving Battery</div>
            <div className="font-mono text-[10px] uppercase tracking-[0.18em] text-slate-500 mt-0.5">/ hub.v2</div>
          </div>
        </a>

        <nav className="hidden md:flex items-center gap-8 text-[13px] text-slate-700">
          <a href="#calculator" className="hover:text-slate-900 transition">Calculator</a>
          <a href="#hubs" className="hover:text-slate-900 transition">Device Hubs</a>
          <a href="#faq" className="hover:text-slate-900 transition">FAQ</a>
        </nav>

        <a href="#calculator" className="group relative inline-flex items-center gap-2 px-4 py-2 rounded-full bg-slate-900 text-[12.5px] font-medium text-bone hover:bg-slate-800 transition">
          <span className="w-1.5 h-1.5 rounded-full bg-amber-400 pulse-amber" />
          <span style={{ color: '#FAF8F5' }}>Run Diagnostic</span>
        </a>
      </div>
    </header>
  )
}

export default Nav
